import { Homework } from "../../models/Homework";
import { Paged } from "../../models/Paged";
import {
  SharedHomework,
  SharedHomeworkRequest,
} from "../../models/SharedHomework";
import { SharingSettings } from "../../models/SharingSettings";
import { slavtHTTP } from "../http";

export function createHomework(exerciseId: number) {
  return slavtHTTP
    .post<Homework>(`/homeworks`, { examId: Number(exerciseId) })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getHomeworkDetails(homeworkId: string) {
  return slavtHTTP
    .get<Homework>(`/homeworks/${homeworkId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editHomework(homework: Partial<Homework>) {
  return slavtHTTP
    .put<void>(`/homeworks/${homework.id}`, homework)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function updateHomeworkStatus(
  homeworkId: string,
  status: { status: Homework["status"]; message?: string },
) {
  return slavtHTTP
    .patch<void>(`/homeworks/${homeworkId}/status`, status)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getHomeworkSharingSettings(homeworkId: string) {
  return slavtHTTP
    .get<SharingSettings>(`/homeworks/${homeworkId}/sharing-settings`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function updateHomeworkSharingSettings(
  homeworkId: string,
  enabled: boolean,
) {
  return slavtHTTP
    .patch<void>(`/homeworks/${homeworkId}/sharing-settings`, { enabled })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getSharedHomeworks(
  sharedHomeworkRequest: SharedHomeworkRequest,
) {
  return slavtHTTP
    .post<Paged<SharedHomework>>(
      `/shared-homeworks/search`,
      sharedHomeworkRequest,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getSharedHomeworkDetails(homeworkSharingCode: string) {
  return slavtHTTP
    .get<Homework>(`/homeworks/sharing-code/${homeworkSharingCode}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
